module.exports = __webpack_public_path__ + "img/teacher-lesson-2.bc6cf79a.png";